import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-router';
import WindowLayout from '../WindowLayout';
import InboxLayout from '../InboxLayout';
import GameQuery from '../../query/GameQuery';
import InboxMessagesList from '../InboxMessagesList';
import InboxMessageRoute from '../../screens/InboxMessageRoute';
import NoMessage from '../../screens/NoMessage';
import WindowOptions from '../WindowOptions';
import WindowIconTitle from '../WindowIconTitle';
import { MESSAGE, INBOX } from '../../routes';
import { Route } from 'react-router-dom';
const Inbox = () => 
	<WindowLayout>
		<Route
			path={INBOX}
			render={props => 
				<WindowLayout.Header>
					<WindowOptions history={props.history} />
					<WindowIconTitle
						className="inbox-window-icon-title"
						icon={'inbox'}
						title={'Mail'}
					/>
				</WindowLayout.Header>
			}
		/>
		<WindowLayout.Body>
			<InboxLayout>
				<InboxLayout.SideBar>
					<Route
						path={INBOX}
						render={props => 
							<GameQuery>
								<InboxMessagesList {...props} />
							</GameQuery>
						}
					/>
				</InboxLayout.SideBar>
				<InboxLayout.Content>
					<Switch>
						<Route path={MESSAGE} component={InboxMessageRoute} />
						<Route path={INBOX} component={NoMessage} />
					</Switch>
				</InboxLayout.Content>
			</InboxLayout>
		</WindowLayout.Body>
	</WindowLayout>
;

Inbox.propTypes = {
	routes: PropTypes.object
};

export default Inbox;
